import { TenantBranding } from "./types";

// njoy's own branding: what a tenant falls back to for anything it leaves unset.
export const DEFAULT_BRANDING = {
  appName: "Njoy",
  shortName: "Njoy",
  primaryColor: "#C553FC",
  secondaryColor: "#0045E9",
  themeColor: "#000000",
  backgroundColor: "#ffffff",
} as const;

/** A tenant's display name, short name and colours, with njoy's for any it leaves unset. */
export const resolveBranding = (branding: TenantBranding | null | undefined) => ({
  appName: branding?.appName || DEFAULT_BRANDING.appName,
  shortName: branding?.shortName || branding?.appName || DEFAULT_BRANDING.shortName,
  primaryColor: branding?.primaryColor || null,
  secondaryColor: branding?.secondaryColor || null,
  logoUrl: branding?.logoUrl || null,
  iconUrl: branding?.iconUrl || null,
  supportEmail: branding?.supportEmail || null,
  websiteUrl: branding?.websiteUrl || null,
});

/**
 * CSS variables a frontend sets on :root for a tenant's colours. Only what the
 * tenant overrides: the stylesheet holds njoy's values as the defaults.
 *   --brand-primary        buttons, highlights (njoy #C553FC)
 *   --brand-primary-light  slider, accents (njoy #DC55FF)
 *   --brand-deep           dark borders and text (njoy #281289)
 *   --brand-gradient-from / --brand-gradient-to  the brand gradient (njoy #A151F9 → #0045E9)
 */
export const brandCssVariables = (branding: TenantBranding | null | undefined): Record<string, string> => {
  const primary = branding?.primaryColor;
  const secondary = branding?.secondaryColor;
  return {
    ...(primary
      ? {
          "--brand-primary": primary,
          "--brand-primary-light": primary,
          "--brand-deep": `color-mix(in srgb, ${primary} 40%, black)`,
          "--brand-gradient-from": primary,
          "--brand-gradient-to": secondary || primary,
        }
      : {}),
    ...(secondary ? { "--brand-gradient-to": secondary } : {}),
  };
};
